/**
 * Friendly, gentle engagement notification messages.
 * These are designed to feel like a kind invitation, never a guilt trip.
 */

export const dailyAgendaMessages = [
  {
    title: "Good afternoon! ☀️",
    body: "What's your focus today? Let's take a look at your tasks together.",
  },
  {
    title: "Hey there! 👋",
    body: "Got anything to tackle today? Let's take a look together.",
  },
  {
    title: "Happy lunchtime! 🍽️",
    body: "A great time to check in. What's on the agenda today?",
  },
  {
    title: "Midday check-in 🌤️",
    body: "Anything you'd like to get done today?",
  },
  {
    title: "Hey, hope your day's going well! 😊",
    body: "Want to take a peek at your tasks for today?",
  },
  {
    title: "Quick hello! 👋",
    body: "Is it time for a little check-in?",
  },
  {
    title: "Lunchtime thoughts 💭",
    body: "What would feel good to accomplish today? Let's find out.",
  },
  {
    title: "Just a quick check-in! 🌟",
    body: "How's your day going? Anything you'd like to focus on today?",
  },
  {
    title: "Hey! How's today going? 🌈",
    body: "Anything you want to get done today?",
  },
];

export const comebackMessages = [
  {
    title: "We miss you! 🌱",
    body: "It's been a few days. I'm here whenever you're ready to jump back in.",
  },
  {
    title: "Hey you! 👋",
    body: "Just wanted to say hi. Mindstack is here whenever you need it.",
  },
  {
    title: "Your tasks are waiting patiently 🐢",
    body: "Take all the time you need. We'll be right here when you're ready.",
  },
  {
    title: "A little hello from Mindstack 💛",
    body: "Hope you're doing well! Feel free to drop back in whenever you'd like",
  },
  {
    title: "Remember us? 😊",
    body: "Your tasks are all safe and sound. They will be here whenever you're ready to check in again.",
  },
  {
    title: "Hey, it's been a bit! 🌻",
    body: "We'd love to see you again whenever you're ready.",
  },
  {
    title: "Thinking of you! 💭",
    body: "Life gets busy, we get it! Just know that Mindstack is here whenever you want to pop back in.",
  },
  {
    title: "Quick wave from Mindstack 🤗",
    body: "Hope things are going well! We're here whenever you'd like to pop back in.",
  },
];

/**
 * Pick a random message from the given array.
 */
export const getRandomMessage = (messages) => {
  const index = Math.floor(Math.random() * messages.length);
  return messages[index];
};
